var map = {
	"./Titan Poker Multihand.png": 4619,
	"./battleforthethrone.jpg": 6330,
	"./beachpenalties.jpg": 4108,
	"./blackjack.jpg": 5058,
	"./bookofegypt.jpg": 6839,
	"./bountyhunters.jpg": 9240,
	"./candysbonanza.jpg": 6679,
	"./capitalcityderby.jpg": 3773,
	"./casinoheist.jpg": 4506,
	"./circusfeverdeluxe.jpg": 7778,
	"./clownfever.jpg": 7783,
	"./crazyhorses.jpg": 2083,
	"./dice.png": 3609,
	"./dicemini.jpg": 6700,
	"./dicemini.png": 1656,
	"./digits.png": 1622,
	"./dotsracing.jpg": 2250,
	"./evoji.jpg": 7405,
	"./expanse-logo.png": 7332,
	"./expanse.png": 4818,
	"./fairyinwonderland.jpg": 5346,
	"./forestrock.png": 6888,
	"./fortunefarm.jpg": 8221,
	"./gatesofolympia.jpg": 8574,
	"./godofcoins.png": 4229,
	"./hilo.png": 8342,
	"./hundredsupericy.jpg": 460,
	"./keno.png": 5741,
	"./leprechaunwish.jpg": 7742,
	"./luckysbettingshop.png": 1322,
	"./magicwheel.png": 4898,
	"./mayastreasure.png": 1830,
	"./mine.png": 8289,
	"./oddoneout.png": 5437,
	"./pia.jpg": 3420,
	"./piggyparty.png": 9380,
	"./pinataloca.png": 6588,
	"./piratespower.jpg": 8949,
	"./pixelpoker.png": 5231,
	"./planetspower.png": 2456,
	"./poker.png": 6597,
	"./richpanda.jpg": 8784,
	"./roulette.png": 7000,
	"./roulettedeluxe.png": 2029,
	"./shaolincrew.jpg": 4943,
	"./sicbo.png": 4000,
	"./spinningbuddha.png": 164,
	"./sticky777.png": 452,
	"./superheli.png": 399,
	"./swipe.png": 4056,
	"./thebookofeskimo.jpg": 2355,
	"./venividivici.png": 6197,
	"./wheel.jpg": 1615,
	"./wildcorrida.png": 3928,
	"./wildicyfruits.png": 7014,
	"./wildwestspirit.jpg": 5474,
	"./wildwhitewhale.png": 9882,
	"./zombieapocalypse.png": 9611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5632;